import { MessageSquare } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { chatWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  chatWeb,
  {
    ChatPage: () => import('./pages/ChatPage'),
    ChatMessagePreview: () => import('./ChatMessagePreview'),
    ChatLauncherPreview: () => import('./ChatLauncherPreview'),
    EntityIdBadgeScanner: () => import('./components/EntityIdBadgeScanner'),
  },
  {
    icons: { MessageSquare },
  },
);
